module.exports = __webpack_public_path__ + "assets/images/bg_6c6a1aacbbee517f066209b9e1fb8a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/bg.png
// module id = 285
// module chunks = 0